/* Sort a collection by heat level, low→high or high→low.
 *
 * WHY THIS IS CLIENT-SIDE. Shopify has no native sort on a metafield, and
 * Liquid cannot read a query parameter, so a `?sort_by=heat-…` value can never
 * be acted on by the server: Shopify ignores the unknown value and returns the
 * collection's default order. Reordering the rendered grid is therefore the
 * only route without an app or a Shopify Function.
 *
 * Because of that, sections/collection.liquid only sets `data-heat-sort` when
 * every product carries custom.heat_level AND the whole collection fits on one
 * page — reordering the DOM can only ever reorder what was rendered. Today
 * that is PepperZ.
 *
 * The two options are INJECTED here rather than server-rendered on purpose:
 * without JS they would submit, Shopify would ignore them, and the shopper
 * would be looking at the default order under a label claiming otherwise. No
 * JS, no option, no lie.
 *
 * assets/facets.js skips its auto-submit for `heat-` values, so choosing one
 * reorders in place instead of reloading to the default order.
 */
(() => {
  'use strict';

  const ASC = 'heat-ascending';
  const DESC = 'heat-descending';
  const LABELS = { [ASC]: 'Heat, low to high', [DESC]: 'Heat, high to low' };

  const heatOf = (card) => {
    const value = parseInt(card.dataset.heat, 10);
    return Number.isFinite(value) ? value : 0;
  };

  function applySort(grid, direction) {
    const cards = Array.from(grid.children);
    // Remember the incoming order so the sort is STABLE: products sharing a
    // heat level keep the order the server sent (alphabetical by default)
    // rather than reshuffling on every re-sort.
    const original = new Map(cards.map((card, i) => [card, i]));
    const sign = direction === DESC ? -1 : 1;

    cards
      .sort((a, b) => (heatOf(a) - heatOf(b)) * sign || original.get(a) - original.get(b))
      .forEach((card) => grid.appendChild(card));
  }

  function init(form) {
    const select = form.querySelector('[data-facet-sort]');
    const grid = document.querySelector('.collection-product-grid');
    if (!select || !grid) return;

    Object.keys(LABELS).forEach((value) => {
      if (select.querySelector(`option[value="${value}"]`)) return;
      const option = document.createElement('option');
      option.value = value;
      option.textContent = LABELS[value];
      select.appendChild(option);
    });

    // Re-apply on load so a shared or reloaded URL shows what it claims.
    const fromUrl = new URLSearchParams(window.location.search).get('sort_by');
    if (fromUrl === ASC || fromUrl === DESC) {
      select.value = fromUrl;
      applySort(grid, fromUrl);
    }

    select.addEventListener('change', () => {
      const value = select.value;
      if (value !== ASC && value !== DESC) return; // facets.js submits the rest
      applySort(grid, value);
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.history.replaceState({}, '', url);
    });
  }

  const boot = () => document.querySelectorAll('[data-heat-sort]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
